import { Product, WishlistCollection } from '../../@types/wishlist.js';

export enum HeadRenderCase {
  RenderCollectionHead = 'RENDER_COLLECTION_HEAD',
  RenderNothing = 'NOTHING',
}

export enum ProductsRenderCase {
  RenderNothing = 'NOTHING',
  RenderCollectionEmptyUnfiltered = 'RENDER_COLLECTION_EMPTY_UNFILTERED',
  RenderProducts = 'RENDER_PRODUCTS',
  RenderEmptyFiltered = 'RENDER_EMPTY_FILTERED',
  RenderEmptyFilteredExternalNotification = 'RENDER_EMPTY_FILTERED_EXTERNAL_NOTIFICATION',
}

export class WishlistRenderCase {
  headRenderCase: HeadRenderCase;
  productsRenderCase: ProductsRenderCase;

  products: Product[] = [];

  private constructor(headRenderCase: HeadRenderCase, productsRenderCase: ProductsRenderCase, products: Product[]) {
    this.headRenderCase = headRenderCase;
    this.productsRenderCase = productsRenderCase;
    this.products = products;
  }

  static determineRenderCase(
    productsOfComponent: Product[],
    filteredProducts: Product[],
    wishlistCollection?: WishlistCollection,
  ): WishlistRenderCase {
    const headRenderCase = this.determineHeadRenderCase(wishlistCollection);
    if (productsOfComponent.length === 0) {
      return WishlistRenderCase.empty(
        headRenderCase,
        wishlistCollection ? ProductsRenderCase.RenderCollectionEmptyUnfiltered : ProductsRenderCase.RenderNothing
      );
    }

    if (filteredProducts.length > 0) {
      return new WishlistRenderCase(headRenderCase, ProductsRenderCase.RenderProducts, filteredProducts);
    }

    if (this.isExternalNotificationCase()) {
      return new WishlistRenderCase(
        headRenderCase,
        ProductsRenderCase.RenderEmptyFilteredExternalNotification,
        productsOfComponent
      );

    }
    return WishlistRenderCase.empty(headRenderCase, ProductsRenderCase.RenderEmptyFiltered);
  }

  private static empty(headRenderCase: HeadRenderCase, productsRenderCase: ProductsRenderCase) {
    return new WishlistRenderCase(headRenderCase, productsRenderCase, []);
  }

  private static isExternalNotificationCase(): boolean {
    const externalNotificationCase = new URL(window.location.href).searchParams.get('btp_kw');
    return externalNotificationCase?.toLowerCase() === 'Wishlist-Shortage'.toLowerCase()
      || externalNotificationCase?.toLowerCase() === 'Wishlist-Reduction'.toLowerCase()
      || externalNotificationCase?.toLowerCase() === 'Wishlist-Reminder'.toLowerCase();
  }

  private static determineHeadRenderCase(wishlistCollection?: WishlistCollection) {
    if (wishlistCollection) {
      return HeadRenderCase.RenderCollectionHead;
    } else {
      return HeadRenderCase.RenderNothing;
    }
  }
}
